import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ConfigService } from '../../../services/config.service';
import { DswFooterComponent } from '@vi-succ/design-system-web';
import { TranslationConfigService } from '../../../services/translation-config.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [DswFooterComponent],
    standalone: true,
})
export class FooterComponent implements OnInit {
    @Input() appTitle = 'Viessmann Account';
    version = environment.version;

    constructor(public configService: ConfigService, public translationConfig: TranslationConfigService) {}

    ngOnInit(): void {
        this.translationConfig.setLanguage(this.configService?.me?.locale);
    }
}
